export var RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP = 'RETAILER_HAS_SEEN_R2M_HEART_ICON_TOOLTIP';
